angular.module('backOffice').constant('numericLimitConstants', {
    WireCompanyMaxLimitAmount: 99999999999.0,
});
